// extracted by mini-css-extract-plugin
export var Stamat = "VideoSection-module--Stamat--INSlk";
export var StamatAlt = "VideoSection-module--StamatAlt--mkh1x";
export var arrow = "VideoSection-module--arrow--xF2y9";
export var bothSidesContainer = "VideoSection-module--bothSidesContainer--6JDDl";
export var buttonContainer = "VideoSection-module--buttonContainer--K7OH2";
export var buttonOrange = "VideoSection-module--buttonOrange--NdkqY";
export var buttonWhite = "VideoSection-module--buttonWhite--fztps";
export var discountCont = "VideoSection-module--discountCont--IGwNm";
export var leftContainer = "VideoSection-module--leftContainer--MDs1C";
export var leftSidePrice = "VideoSection-module--leftSidePrice--j1DqU";
export var oldPrice = "VideoSection-module--oldPrice--GTKd1";
export var overStamat = "VideoSection-module--overStamat--AL+iW";
export var playerWrapper = "VideoSection-module--playerWrapper--B+53W";
export var priceContainer = "VideoSection-module--priceContainer--41zxh";
export var reactPlayer = "VideoSection-module--reactPlayer--JZB4q";
export var rightSide = "VideoSection-module--rightSide--EAX4q";
export var timeLeft = "VideoSection-module--timeLeft--8e1Mt";
export var videoAndStamat = "VideoSection-module--videoAndStamat--G63R0";
export var videoSection = "VideoSection-module--videoSection--pqNQn";
export var vsBG = "VideoSection-module--vsBG--ToHzy";